import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M13.4141 12L16.7071 8.70701C17.0981 8.31601 17.0981 7.68401 16.7071 7.29301C16.3161 6.90201 15.6841 6.90201 15.2931 7.29301L12.0001 10.586L8.7071 7.29301C8.3161 6.90201 7.6841 6.90201 7.2931 7.29301C6.9021 7.68401 6.9021 8.31601 7.2931 8.70701L10.5861 12L7.2931 15.293C6.9021 15.684 6.9021 16.316 7.2931 16.707C7.4881 16.902 7.7441 17 8.0001 17C8.2561 17 8.5121 16.902 8.7071 16.707L12.0001 13.414L15.2931 16.707C15.4881 16.902 15.7441 17 16.0001 17C16.2561 17 16.5121 16.902 16.7071 16.707C17.0981 16.316 17.0981 15.684 16.7071 15.293L13.4141 12Z",
];

export function CloseIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
